import { render } from "./TextUpload.vue?vue&type=template&id=09b5d6c6"
import script from "./TextUpload.vue?vue&type=script&lang=js"
export * from "./TextUpload.vue?vue&type=script&lang=js"

import "./TextUpload.vue?vue&type=style&index=0&id=09b5d6c6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__